import { OnInit } from '@angular/core';
import { Component } from '@angular/core';

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html'
})
export class AppMenuComponent implements OnInit {

    model: any[] = [];

    ngOnInit() {
        this.model = [
            {
                label: 'Configuration',
                icon: 'pi pi-fw pi-users',
                items: [
                    {
                        label: 'ApiClients',
                        icon: 'pi pi-fw pi-users',
                        routerLink: ['/configuration/app-apiclient'],
                    },
                    {
                        label: 'ApiClient Keys',
                        icon: 'pi pi-fw pi-key',
                        routerLink: ['/configuration/apiclient-environment-key'],
                    },
                    {
                        label: 'ApiClient Certificates',
                        icon: 'pi pi-fw pi-file',
                        routerLink: ['/configuration/apiclient-certificate'],
                    },
                    {
                        label: 'ApiClient IpAddress',
                        icon: 'pi pi-fw pi-envelope',
                        routerLink: ['/configuration/apiclient-address'],
                    },
                    {
                        label: 'ApiEnvironments',
                        icon: 'pi pi-fw pi-home',
                        routerLink: ['/configuration/app-apienvironment'],
                    },
                    {
                        label: 'ApiClientCompanies',
                        icon: 'pi pi-fw pi-building',
                        routerLink: ['/configuration/app-apiclientcompany'],
                    },
                    {
                        label: 'ApiServices',
                        icon: 'pi pi-fw pi-server',
                        routerLink: ['/configuration/app-apiservice'],
                    }
                ]
            }
        ];
    }
}
